/* eslint-disable react/jsx-key */
import React from 'react';
import { makeStyles } from '@material-ui/core';

interface Props {
  provider: any;
}

const useStyles = makeStyles({
  content: {
    '& p': {
      margin: 0
    }
  }
});

function convertToEmbedUrl(youtubeUrl: string) {
  const videoIdMatch = youtubeUrl.match(
    /(?:[?&]v=|\/(?:v|embed|shorts)\/|youtu\.be\/|\/watch\?(?:[^&]*&)?v=)([^&\n?#]+)/
  );

  if (!videoIdMatch) {
    return youtubeUrl;
  }

  const videoId = videoIdMatch ? videoIdMatch[1] : null;

  return `https://www.youtube.com/embed/${videoId}`;
}

const Main = ({ provider }: Props) => {
  const classes = useStyles();

  return (
    <div
      style={{
        padding: '3rem',
        fontSize: '1rem',
        whiteSpace: 'pre-wrap'
      }}
    >
      {provider.computed_about_us && (
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: provider.computed_about_us
          }}
        ></div>
      )}

      {provider.key_features && (
        <>
          <h2>Key Features</h2>
          <div
            className={classes.content}
            dangerouslySetInnerHTML={{
              __html: provider.key_features
            }}
          ></div>
        </>
      )}
      {provider.videos.length > 0 &&
        provider.videos.map((video: any, index: number) => {
          const embedUrl =
            video.url != 'null' ? convertToEmbedUrl(video.url) : video.file_url;

          return (
            embedUrl && (
              <>
                <h2>{video.title}</h2>
                <div
                  key={index}
                  style={{
                    position: 'relative',
                    paddingBottom: '56.25%',
                    height: '0',
                    overflow: 'hidden',
                    maxWidth: '100%',
                    marginTop: '1rem'
                  }}
                >
                  {video.url ? (
                    <iframe
                      src={embedUrl}
                      title={video.title}
                      frameBorder="0"
                      allowFullScreen
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        right: '0',
                        width: '90%',
                        height: '100%',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    ></iframe>
                  ) : (
                    <video
                      controls
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%'
                      }}
                    >
                      <source src={embedUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              </>
            )
          );
        })}
    </div>
  );
};

export default Main;
